import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-guest-view',
  templateUrl: './guest-view.component.html',
  styleUrls: ['./guest-view.component.css']
})
export class GuestViewComponent implements OnInit {

  guestID: string;
  guestData: any;
  enableGuestView:boolean = false;
  constructor(
      public api: ApiService,
      public router: Router,
      public route: ActivatedRoute,
      public swal: SweetAlert,
      public storage: StorageService,
  ) {
      this.route.paramMap.subscribe((params: any) => {
        this.guestID = params.params.guestID;
      });
  }
  ngOnInit() {
      this.getGuestData();
  }
  getGuestData() {
      const obj = {
          guestID: this.guestID
      };
      this.api.transportManagerGuestList(obj).then((res: any) => {
          if (res.status == 'success') {
              this.guestData = res.data[0];
          }
      }).catch((err) => {
          console.log(err);
      });
      setTimeout(()=>{ this.enableGuestView = true; },100);
  }

}
